// @flow

const getSocialShareConfig = (facebookAppId: number, sharingHref: string,
  pinterestLogo: string, sharingText: string, emailSubject: string) => {
  const encodedHref = encodeURIComponent(sharingHref);
  const encodedText = encodeURIComponent(sharingText);
  const sharingContent = encodeURIComponent(`${sharingText} ${sharingHref}`);
  const encodedEmailSubject = encodeURIComponent(emailSubject);

  return {
    facebookAppId,
    encodedFacebookShareLink: encodedHref,
    encodedTwitterText: encodedText,
    encodedTwitterShareLink: encodedHref,
    encodedPinterestShareLink: sharingContent,
    eventLogoUrl: pinterestLogo,
    encodedEmailSubject,
    encodedEmailBody: sharingContent,
    encodedSmsText: `${sharingText} ${sharingHref}`,
  };
};

export default getSocialShareConfig;
